import Hotspot from './Hotspot'

export default Hotspot
